import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-book-card-selectable',
	templateUrl: './book-card-selectable.component.html',
	styleUrl: './book-card-selectable.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BookCardSelectableComponent {
	@Input() book: any;

	@Input() selected = false;

	@Output() eventSelected = new EventEmitter();

	selectBook() {
		this.eventSelected.emit(this.book);
	}
}
